import { CALL_API } from 'middlewares/api';
import { url } from 'configs';
import { buildPageMeta } from 'containers/App/screens/Tube/utils';

const { NEWTUBE_API_SERVER } = url;

const FETCH_ORDERLIST_REQUEST = 'tube/orders/active/FETCH_ORDERLIST_REQUEST';
const FETCH_ORDERLIST_SUCCESS = 'tube/orders/active/FETCH_ORDERLIST_SUCCESS';
const FETCH_ORDERLIST_ERROR = 'tube/orders/active/FETCH_ORDERLIST_ERROR';

const FETCH_ORDERDATA_REQUEST = 'tube/orders/active/FETCH_ORDERDATA_REQUEST';
const FETCH_ORDERDATA_SUCCESS = 'tube/orders/active/FETCH_ORDERDATA_SUCCESS';
const FETCH_ORDERDATA_ERROR = 'tube/orders/active/FETCH_ORDERDATA_ERROR';

const FETCH_ORDERADMINDATA_REQUEST =
  'tube/orders/active/FETCH_ORDERADMINDATA_REQUEST';
const FETCH_ORDERADMINDATA_SUCCESS =
  'tube/orders/active/FETCH_ORDERADMINDATA_SUCCESS';
const FETCH_ORDERADMINDATA_ERROR =
  'tube/orders/active/FETCH_ORDERADMINDATA_ERROR';

const FETCH_ORDERPAIDTOTAL_REQUEST =
  'tube/orders/active/FETCH_ORDERPAIDTOTAL_REQUEST';
const FETCH_ORDERPAIDTOTAL_SUCCESS =
  'tube/orders/active/FETCH_ORDERPAIDTOTAL_SUCCESS';
const FETCH_ORDERPAIDTOTAL_ERROR =
  'tube/orders/active/FETCH_ORDERPAIDTOTAL_ERROR';

const FETCH_ORDERPAID_REQUEST = 'tube/orders/active/FETCH_ORDERPAID_REQUEST';
const FETCH_ORDERPAID_SUCCESS = 'tube/orders/active/FETCH_ORDERPAID_SUCCESS';
const FETCH_ORDERPAID_ERROR = 'tube/orders/active/FETCH_ORDERPAID_ERROR';

export default function reducer(
  state = {
    orderList: {
      isLoadingList: false,
      data: [],
    },
    orderData: {
      isLoadingData: false,
      data: [],
    },
    orderAdmin: {
      isLoadingAdmin: false,
      data: [],
    },
    orderPaidTotal: {
      isLoadingPaidTotal: false,
      data: [],
    },
    orderPaid: {
      isLoadingPaidTotal: false,
      data: [],
    },
    orderListMeta: {},
    orderDataMeta: {},
    orderAdminMeta: {},
    orderPaidTotalMeta: {},
    orderPaidMeta: {},
  },
  action
) {
  switch (action.type) {
    case FETCH_ORDERLIST_REQUEST:
      return Object.assign({}, state, {
        orderList: {
          isLoadingList: true,
        },
      });
    case FETCH_ORDERLIST_SUCCESS:
      return Object.assign({}, state, {
        orderList: {
          isLoadingList: false,
          data: action.response.data,
        },
        orderListMeta: buildPageMeta(action.response.meta),
      });
    case FETCH_ORDERDATA_REQUEST:
      return Object.assign({}, state, {
        orderData: {
          isLoadingData: true,
        },
      });
    case FETCH_ORDERDATA_SUCCESS:
      return Object.assign({}, state, {
        orderData: {
          isLoadingData: false,
          data: action.response.data,
        },
        orderDataMeta: buildPageMeta(action.response.meta),
      });
    case FETCH_ORDERADMINDATA_REQUEST:
      return Object.assign({}, state, {
        orderAdmin: {
          isLoadingAdmin: true,
        },
      });
    case FETCH_ORDERADMINDATA_SUCCESS:
      return Object.assign({}, state, {
        orderAdmin: {
          isLoadingAdmin: false,
          data: action.response.data,
        },
        orderAdminMeta: buildPageMeta(action.response.meta),
      });
    case FETCH_ORDERPAIDTOTAL_REQUEST:
      return Object.assign({}, state, {
        orderPaidTotal: {
          isLoadingPaidTotal: true,
        },
      });
    case FETCH_ORDERPAIDTOTAL_SUCCESS:
      return Object.assign({}, state, {
        orderPaidTotal: {
          isLoadingPaidTotal: false,
          data: action.response.data,
        },
        orderPaidTotalMeta: buildPageMeta(action.response.meta),
      });
    case FETCH_ORDERPAID_REQUEST:
      return Object.assign({}, state, {
        orderPaid: {
          isLoadingPaid: true,
        },
      });
    case FETCH_ORDERPAID_SUCCESS:
      return Object.assign({}, state, {
        orderPaid: {
          isLoadingPaid: false,
          data: action.response.data,
        },
        orderPaidMeta: buildPageMeta(action.response.meta),
      });
    default:
      return state;
  }
}

// 進行中訂單列表
export function fetchOrderList(pageNumber) {
  return {
    [CALL_API]: {
      url:
        NEWTUBE_API_SERVER +
        'Ordering/OrderListProcess?pageNumber=' +
        pageNumber,
      method: 'GET',
      headers: {
        functionCode: 'OrderEmp',
        actionCode: 'Default',
      },
      types: [
        FETCH_ORDERLIST_REQUEST,
        FETCH_ORDERLIST_SUCCESS,
        FETCH_ORDERLIST_ERROR,
      ],
    },
  };
}

// 單筆
export function fetchOrderData(orderId) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Ordering/' + orderId,
      method: 'GET',
      headers: {
        functionCode: 'OrderEmp',
        actionCode: 'Default',
      },
      types: [
        FETCH_ORDERDATA_REQUEST,
        FETCH_ORDERDATA_SUCCESS,
        FETCH_ORDERDATA_ERROR,
      ],
    },
  };
}

// 管理訂單單筆
export function fetchOrderAdminData(OrderingId) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Ordering/Management/' + OrderingId,
      method: 'GET',
      headers: {
        functionCode: 'OrderEmp',
        actionCode: 'Manage',
      },
      types: [
        FETCH_ORDERADMINDATA_REQUEST,
        FETCH_ORDERADMINDATA_SUCCESS,
        FETCH_ORDERADMINDATA_ERROR,
      ],
    },
  };
}

// 管理訂單 - 總計結果
export function fetchOrderPaidTotal(OrderingId) {
  return {
    [CALL_API]: {
      url:
        NEWTUBE_API_SERVER + 'Ordering/Management/TotalOrderItem/' + OrderingId,
      method: 'GET',
      headers: {
        functionCode: 'OrderEmp',
        actionCode: 'Manage',
      },
      types: [
        FETCH_ORDERPAIDTOTAL_REQUEST,
        FETCH_ORDERPAIDTOTAL_SUCCESS,
        FETCH_ORDERPAIDTOTAL_ERROR,
      ],
    },
  };
}

// 管理訂單 - 收費管理
export function fetchOrderPaid(OrderingId, payerName) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'Ordering/Management/PaidOrder/' + OrderingId,
      method: 'GET',
      headers: {
        functionCode: 'OrderEmp',
        actionCode: 'Manage',
      },
      types: [
        FETCH_ORDERPAID_REQUEST,
        FETCH_ORDERPAID_SUCCESS,
        FETCH_ORDERPAID_ERROR,
      ],
      params: payerName,
    },
  };
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/Orders/screens/Active/reducers/index.js
 **/